import { render } from "./MarcaPadraoModal.vue?vue&type=template&id=7e75db1a&scoped=true&ts=true"
import script from "./MarcaPadraoModal.vue?vue&type=script&lang=ts"
export * from "./MarcaPadraoModal.vue?vue&type=script&lang=ts"

import "./MarcaPadraoModal.vue?vue&type=style&index=0&id=7e75db1a&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e75db1a"]])

export default __exports__